import http from "../hooks/http-common";
import { v4 as uuidv4 } from "uuid";

const upload = (file, token, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/campaigns/uploadImage", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + token,
    },
    onUploadProgress,
  });
};

const uploadCanvas = (file, token, camp_id, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", file);
  formData.append("camp_id", camp_id);

  return http.post("/campaigns/uploadImage", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + token,
    },
    onUploadProgress,
  });
};

const uploadVideo = async (file, token, onUploadProgress) => {
  // console.log(file.name)

  let formData = new FormData();

  //Get the file Extension
  let fileExtension = file.name.split(".").pop();

  formData.append("file", file, uuidv4() + "." + fileExtension);

  const response = await http.post("/campaigns/uploadVideo", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + token,
    },
    onUploadProgress,
  });

  // console.log(response);

  return response;
};

const uploadAudio = async (file, token, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/campaigns/uploadAudio", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + token,
    },
    onUploadProgress,
  });
};

const getFiles = () => {
  return http.get("/campaigns/files");
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  upload,
  uploadVideo,
  getFiles,
  uploadAudio,
  uploadCanvas,
};
